import { CustomIconUrl } from "@p0security/shared/integrations/constants";
import { AwsIntegration } from "@p0security/shared/integrations/resources/aws/types";
import { AzureIntegration } from "@p0security/shared/integrations/resources/azure/types";
import { CustomIntegrationComponents } from "@p0security/shared/integrations/resources/custom/components";
import { GcloudIntegration } from "@p0security/shared/integrations/resources/gcloud/types";
import { useFirestoreDoc } from "providers/FirestoreProvider";
import { useCallback } from "react";

import { Install, InstallProps } from "../Install/Install";
import { customIntegrationInstaller } from "./install/install";

export const Custom = (
  props: Pick<
    InstallProps<typeof CustomIntegrationComponents>,
    "cardOverride" | "onInstall"
  >
) => {
  const itemKind = useCallback(() => "resource", []);

  const awsIntegrationDoc = useFirestoreDoc<AwsIntegration>(
    "integrations/aws",
    {
      tenantAware: true,
    }
  );

  const gcloudIntegrationDoc = useFirestoreDoc<GcloudIntegration>(
    "integrations/gcloud",
    {
      tenantAware: true,
    }
  );

  const azureIntegrationDoc = useFirestoreDoc<AzureIntegration>(
    "integrations/azure",
    {
      tenantAware: true,
    }
  );

  const cspConfigs = {
    aws: awsIntegrationDoc,
    gcloud: gcloudIntegrationDoc,
    azure: azureIntegrationDoc,
  };

  return (
    <Install<typeof CustomIntegrationComponents>
      components={CustomIntegrationComponents}
      installer={customIntegrationInstaller(cspConfigs)}
      integration="custom"
      itemKind={itemKind}
      logo={CustomIconUrl}
      title={"Custom"}
      {...props}
    />
  );
};
